
import React from "react";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from "recharts";

export const MonthlySpending = () => {
  // Mock data - in a real app, this would come from an API
  const data = [
    { month: "Jan", amount: 24500 },
    { month: "Feb", amount: 28000 },
    { month: "Mar", amount: 32000 },
    { month: "Apr", amount: 35500 },
    { month: "May", amount: 38000 },
    { month: "Jun", amount: 42000 },
    { month: "Jul", amount: 45000 },
    { month: "Aug", amount: 48500 }
  ];

  return (
    <div className="h-[200px]">
      <ChartContainer
        config={{
          spending: { color: "#F59E0B" }
        }}
      >
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="month" axisLine={false} tickLine={false} />
          <YAxis 
            axisLine={false} 
            tickLine={false}
            tickFormatter={(value) => `$${(value / 1000).toFixed(0)}k`}
          />
          <Bar 
            dataKey="amount" 
            fill="#F59E0B" 
            radius={[4, 4, 0, 0]} 
            name="Monthly Spending"
          />
          <ChartTooltip
            content={
              <ChartTooltipContent
                formatter={(value) => [`$${(value).toLocaleString()}`, "Spending"]}
              />
            }
          />
        </BarChart>
      </ChartContainer>
    </div>
  );
};
